<template>
  <div>
    <vx-card title="Venue Details" class="mb-base">
      <!-- Avatar -->
      <div class="vx-row">
        <!-- Avatar Col -->
        <div class="vx-col" id="avatar-col">
          <!-- <div class="img-container mb-4">
              <img :src="user_data.avatar" class="rounded w-full" />
          </div>-->
        </div>

        <!-- Information - Col 1 -->
        <div class="vx-col flex-1" id="account-info-col-1">
          <table>
            <tr>
              <td class="font-semibold">Venue Name</td>
              <td>{{ venue.name }}</td>
            </tr>
            <tr>
              <td class="font-semibold">Venue Type</td>
              <td>{{ venue.typeName }}</td>
            </tr>
            <tr>
              <td class="font-semibold">Display Name</td>
              <td>{{ venue.displayName }}</td>
            </tr>
            <tr>
              <td class="font-semibold">House Number</td>
              <td>
                &nbsp; {{ venue.houseNumber ? venue.houseNumber : "----" }}
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Telephone</td>
              <td>{{ venue.telephone }}</td>
            </tr>
          </table>
        </div>
        <!-- /Information - Col 1 -->

        <!-- Information - Col 2 -->
        <div class="vx-col flex-1" id="account-info-col-2">
          <table>
            <tr>
              <td class="font-semibold">Street</td>
              <td>{{ venue.street }}</td>
            </tr>
            <tr>
              <td class="font-semibold">Postal Code</td>
              <td>{{ venue.postalCode }}</td>
            </tr>
            <tr>
              <td class="font-semibold">City</td>
              <td>{{ venue.city }}</td>
            </tr>
            <tr>
              <td class="font-semibold">Country</td>
              <td>{{ venue.country }}</td>
            </tr>
            <tr>
              <td class="font-semibold">Max Allowed Booking</td>
              <td>{{ venue.maxBooking }}</td>
            </tr>
          </table>
        </div>
        <!-- /Information - Col 2 -->
        <div class="vx-col mt-5 w-full flex" id="account-manage-buttons">
          <vs-button
            icon-pack="feather"
            icon="icon-edit"
            class="mr-4"
            :to="{ name: 'edit-venue', params: { venueId: $route.params.id } }"
            >Edit</vs-button
          >
          <vs-button
            type="border"
            color="danger"
            icon-pack="feather"
            icon="icon-trash"
            @click="confirmDeleteRecord"
            >Delete</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card>
      <div class="con-expand-users w-full">
        <div class="con-btns-user flex items-center justify-between">
          <div class="con-userx flex items-center justify-start">
            <b>Portals List</b>
          </div>
          <div class="flex">
            <vs-button
             @click="setVenueIndex(venueId)"
              type="border"
              color="success"
              size="small"
              icon-pack="feather"
              icon="icon-plus"
              class="mr-2"
              >Add Portal</vs-button
            >
          </div>
        </div>
        <div class="w-full mt-2">
          <vs-table :data="vPortals" pagination :max-items="itemsPerPage">
            <template slot="thead">
              <vs-th>Type</vs-th>
              <vs-th>Role</vs-th>
              <vs-th>Username</vs-th>
              <vs-th>Password</vs-th>
              <vs-th>DeviceID</vs-th>
              <vs-th>Status</vs-th>
              <vs-th>Actions</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr
                :data="ptr"
                :key="indexptr"
                v-for="(ptr, indexptr) in data"
              >
                <vs-td :data="ptr.type">{{
                  ptr.type ? ptr.type : "---"
                }}</vs-td>
                <vs-td :data="ptr.role">{{
                  ptr.role ? ptr.role : "---"
                }}</vs-td>
                <vs-td>{{
                  ptr.user && ptr.type != "device" ? ptr.user.email : "---"
                }}</vs-td>
                <vs-td>{{
                  ptr.user && ptr.type != "device"
                    ? ptr.user.api_password
                    : "---"
                }}</vs-td>
                <vs-td :data="ptr.device_id">{{ ptr.device_id }}</vs-td>
                <vs-td>
                  <div
                    class="color-radio rounded-full mx-3"
                    v-if="ptr.type == 'device'"
                  >
                    <div
                      v-if="ptr.user"
                      class="h-4 w-4 rounded-full"
                      :style="
                        itemColor({
                          color:
                            ptr.user.status == 'online' ? '#28C76F' : '#EA5455',
                          style: ['backgroundColor'],
                        })
                      "
                    ></div>
                  </div>
                </vs-td>
                <vs-td class="whitespace-no-wrap">
                  <div class="flex">
                    <vs-button
                      @click.stop="editPortal(ptr)"
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="mr-2"
                      >Edit Portal</vs-button
                    >
                    <vs-button
                      color="danger"
                      @click.stop="deletePortal(ptr)"
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-trash"
                      class="mr-2"
                      >Delete Portal</vs-button
                    >
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
      <vs-popup title="Select portal " :active.sync="portalChoicePopup">
            <portal-types @selectPortalType="setPortalType" />

            <!-- this popup is used in case of online and delivery selection  -->
            <vs-popup
              :title="'Add ' + portal.type + ' Portal'"
              :active.sync="onlinePortalPopup"
            >
              <online-delivery-portal
                :role-options="roleOptions"
                @addParentPortal="updatePortalUI"
              />
            </vs-popup>

            <vs-popup title="Add New Device" :active.sync="devicePortalPopup">
              <online-delivery-portal
                :role-options="roleOptions"
                @addParentPortal="updatePortalUI"
              />
            </vs-popup>

            <vs-popup title="Add API Portal" :active.sync="apiPortalPopup">
              <api-portal @addParentPortal="updatePortalUI" />
            </vs-popup>

            <vs-popup
              class="text-center"
              title="QR Booker"
              :active.sync="qrPopup"
            >
              <div class="append-text btn-addon">
                <vs-button
                  type="border"
                  @click="generateQR"
                  class="whitespace-no-wrap"
                  >Generate QR Code</vs-button
                >
                <vs-button
                  type="border"
                  @click="removeQR"
                  class="ml-2 whitespace-no-wrap"
                  >Remove QR Code</vs-button
                >
              </div>

              <img
                class="mt-4"
                v-if="venue_qr_exists"
                :src="main_domain + '/qrcodes/venue-' + venueIndex + '.svg'"
                alt=""
              />
            </vs-popup>
          </vs-popup>
          <vs-popup
            :title="'Edit ' + portal.type + ' Portal'"
            :active.sync="editOnlinePortalPopup"
          >
            <online-delivery-portal
              :role-options="roleOptions"
              @updateParentPortal="updatePortalUI"
            />
          </vs-popup>

    </vx-card>
          <vs-popup
            :title="'Edit Device Settings'"
            :active.sync="editDevicePortalPopup"
          >
            <portal-settings
              @updateConfigParent="updatePortalSettings"
            ></portal-settings>
          </vs-popup>
  </div>
</template>
<script>
import { _show, _delete,   _deletePortal,
  _updatePortalSettings,
  _generateQR,
  _removeQR } from "@/services/Venue";

import { _update_user_status } from "@/services/User";


import { MAIN_DOMAIN } from '@/environment'

import vSelect from "vue-select";
import { Validator } from "vee-validate";

import PortalTypes from "./PortalTypesPopup";
import OnlineDeliveryPortal from "./OnlineDelivery";
import PortalSettings from "./PortalSettings";
import ApiPortal from "./ApiPortal";
import modulePortal from "@/store/portal/modulePortalManagement.js";
import { _permissions } from "@/services/Portal";

const dict = {
  custom: {
    portal_username: {
      required: "Please enter username",
    },
    portal_password: {
      required: "Please enter password",
    },
    portal_role: {
      required: "Please select role",
    },
    portal_device: {
      required: "Please enter device address",
    },
  },
};

Validator.localize("en", dict);

export default {
  components: {
    vSelect,
    PortalTypes,
    OnlineDeliveryPortal,
    PortalSettings,
    ApiPortal,
  },
  mounted() {
    this.$store.registerModule("portalModule", modulePortal);
    this.venueId = this.$route.params.id;
    this.getVenue(this.venueId);
  },
  beforeDestroy: function () {
    this.$store.unregisterModule("portalModule");
  },
  computed: {
    portal: {
      get() {
        return this.$store.state.portalModule;
      },
    },
    itemColor() {
      return (obj) => {
        let style_obj = {}

        obj.style.forEach(p => { style_obj[p] = obj.color })

        return style_obj
      }
    },
  },

  data() {
    return {
      venueId: "",
      venue: {},
      vPortals: [],
      itemsPerPage: 10,

      main_domain : MAIN_DOMAIN,
      portalChoicePopup: false,
      onlinePortalPopup: false,
      devicePortalPopup: false,
      apiPortalPopup: false,
      qrPopup: false,
      editOnlinePortalPopup: false,
      editDevicePortalPopup: false,
      roleOptions: [
        { label: "Basic", value: "basic" },
        { label: "Reception", value: "reception" },
        { label: "Kiosk", value: "kiosk" },
      ],

      venue_qr_exists: false
    };
  },
  methods: {
    getVenue(venueId) {
      _show(venueId)
        .then((response) => {
          this.venue = response.data.obj.venue;
          this.vPortals = response.data.obj.portals;
        })
        .catch((error) => {
          this.$vs.notify({
            title: error.response.data.responseTitle,
            text: error.response.data.responseMessage,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },

    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Delete`,
        text: `You are about to delete "${this.venue.displayName}"`,
        accept: this.deleteRecord,
        acceptText: "Delete",
      });
    },

    deleteRecord() {
      _delete(this.venueId)
        .then((response) => {
          this.$vs.notify({
            title: response.data.responseTitle,
            text: response.data.responseMessage,
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success",
          });
          this.$router.push({ name: "list-venues" });
        })
        .catch((error) => {
          this.$vs.notify({
            title: error.response.data.responseTitle,
            text: error.response.data.responseMessage,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.user_data.id)
      //   .then(()   => { this.$router.push({name:'app-user-list'}); this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },

    setVenueIndex(venueID) {
      this.portalChoicePopup = true;
      this.venueIndex = venueID;
      this.venue_qr_exists = this.venue.qr_exists == 1 ? true:false
    },

    setPortalType(portalType) {

      this.errors.clear();
      if (portalType == "online") {
        this.portal.role = { label: "Basic", value: "basic" };
        this.onlinePortalPopup = true;
      }
      else if (portalType == "device") {
        this.devicePortalPopup = true;
      }
      else if (portalType == "delivery") {
        this.portal.role = { label: "Delivery", value: "delivery" };
        this.onlinePortalPopup = true;
      }
      else if (portalType == "api") {
        this.apiPortalPopup = true;
      }
      else if (portalType == "qr-booker")
      {
        this.qrPopup = true;
      }
      this.$store.dispatch("portalModule/updatePortal", {
        type: portalType,
        venue_id: this.venueIndex,
        role: this.portal.role,
      });
      this.$store.dispatch("portalModule/setPortalPermission", {
        permissions: "",
      });

    },

    listen() {
      this.$echo
        .join("taxipoint")
        .here((users) => {
          const onlineUsers = users.filter(
            (u) =>
              u.id !== this.$store.state.AppActiveUser.uid &&
              u.status === "offline"
          );
          onlineUsers.map((o) => {
            let model = this.allPortals.find((p) => p.user_id == o.id);
            if (model) {
              let v_idx = this.venues.findIndex((v) => v.id === model.venue_id);
              let selectedVenuePortals = this.venues[v_idx].portals;
              let p_idx = selectedVenuePortals.findIndex(
                (p) => p.user_id === o.id
              );
              let v_portal = selectedVenuePortals[p_idx];
              if (v_portal) {
                v_portal.user.status = "online";
              }
              this.venues[v_idx].portals.splice(p_idx, 1, v_portal);
            }
          });
        })
        .joining((user) => {
         this.portalJoined(user);
        })
        .leaving((user) => {
          this.portalLeft(user);
        });
    },

    portalJoined(user) {
      let p_idx = this.vPortals.findIndex((p) => p.user_id === user.id);
      let v_portal = this.vPortals[p_idx]; // get portal to update
      if (v_portal) {
        v_portal.user.status = "online";
        _update_user_status(v_portal.user.id, { status: "online" }); // calling api
        this.vPortals.splice(p_idx, 1, v_portal);
      }
    },

    portalLeft(user) {
      let p_idx = this.vPortals.findIndex((p) => p.user_id === user.id);
      let v_portal = this.vPortals[p_idx]; // get portal to update
      if (v_portal) {
        v_portal.user.status = "offline";
        _update_user_status(v_portal.user.id, { status: "offline" }); // calling api
        this.vPortals.splice(p_idx, 1, v_portal);
      }
    },

    updatePortalUI(response, calltype = "add") {
      let localPortal = response.data.obj.portal;
      if (calltype == "edit") {
        this.updatePortalRow(localPortal);
        this.editOnlinePortalPopup = false;
        this.apiPortalPopup = false;
      } else {
        this.vPortals.push(localPortal);

        this.onlinePortalPopup = false;
        this.devicePortalPopup = false;
        this.apiPortalPopup = false;
        this.portalChoicePopup = false;
      }
      this.$store.dispatch("portalModule/resetPortal");
    },

    editPortal(val) {

      if (val.type == "api") {
        // get portal permissions
        _permissions(val.id).then((res) => {
          this.$store.dispatch(
            "portalModule/setPortalPermission",
            res.data.obj
          );
        });
      }
      this.errors.clear();
      let localRole = {};
      console.log(val.type);
      switch (val.role) { // val.role
        case "delivery":
          localRole = { label: "delivery", value: "delivery" };
          break;
        case "basic":
          localRole = { label: "Basic", value: "basic" };
          break;
        case "reception":
          localRole = { label: "Reception", value: "reception" };
          break;
        case "kiosk":
          localRole = { label: "Kiosk", value: "kiosk" };
          break;
        default:
          break;
      }

      this.$store.dispatch("portalModule/updatePortal", {
        id: val.id,
        device_id: val.device_id,
        username: val.user.api_username,
        password: val.user.api_password,
        type: val.type,
        duration: val.duration,
        venue_id: val.venue_id,
        config: val.config,
        role: localRole,
        customer_id: val.user.customer_id,
        capabilities: val.capabilities,
      });

      if (val.type == "device") {
        this.venueIndex = val.venue_id;
        this.editDevicePortalPopup = true;
      } else if (val.type == "api") {
        this.apiPortalPopup = true;
      } else {
        this.editOnlinePortalPopup = true;
      }
    },

    deletePortal(val) {
      this.$vs.loading();
      _deletePortal(val.venue_id, val.id)
        .then(
          (response) => {
            this.$vs.loading.close();
            const selectedPortalIndex = this.vPortals.findIndex(
              (p) => p.id == val.id
            );
            this.vPortals.splice(
              selectedPortalIndex,
              1
            );
            this.$vs.notify({
              title: response.data.responseTitle,
              text: response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-check-circle",
              color: "success",
            });
          },
          (error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: error.response.data.responseTitle,
              text: error.response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-cross-circle",
              color: "danger",
            });
          }
        )
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: error.response.data.responseTitle,
            text: error.response.data.responseMessage,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },

    updatePortalSettings(response) {
      this.updatePortalRow(response.data.obj.portal);
      this.editDevicePortalPopup = false;
      this.venueIndex = -1;
      this.$store.dispatch("portalModule/resetPortal");
    },

    updatePortalRow(localPortal) {
      // const selectedVenueIndex = this.venues.findIndex(
      //   (v) => v.id == localPortal.venue_id
      // );
      // const selectedVen = this.venues[selectedVenueIndex];
      const selectedPortalIndex = this.vPortals.findIndex(
        (p) => p.id == localPortal.id
      );
      this.$set(
        this.vPortals,
        selectedPortalIndex,
        localPortal
      );
    },

    generateQR() {
      this.$vs.loading();
      _generateQR(this.venueIndex)
        .then(
          (response) => {
            this.$vs.loading.close();
            this.venue_qr_exists =  true
            this.venue.qr_exists = 1;
          },
          (error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: error.response.data.responseTitle,
              text: error.response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-cross-circle",
              color: "danger",
            });
          }
        )
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            text: error.message,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },

    removeQR() {
      this.$vs.loading();
      _removeQR(this.venueIndex)
        .then(
          (response) => {
            this.$vs.loading.close();
            this.venue_qr_exists =  false
            this.venue.qr_exists = 0


          },
          (error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: error.response.data.responseTitle,
              text: error.response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-cross-circle",
              color: "danger",
            });
          }
        )
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            text: error.message,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },
  },
};
</script>
